import _ from "lodash";

export default {
    methods: {
        isEqualWithCustomizer: function (value, other) {
            if (_.isNumber(value) && _.isNumber(other)) {
                return (Math.round(value * 1000) === Math.round(other * 1000));
            }
            /**
             * @link https://lodash.com/docs/4.17.15#isEqualWith
             * If customizer returns undefined, comparisons are handled by the method instead.
             */
            return undefined;
        },
    },
}
